import WhetherIconContainer from "../../components/icon/whetherIcon";

const WhetherIcon = () => {
  return <WhetherIconContainer />;
};

export default WhetherIcon;
